import { FeedbackSectionId } from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';

const LAST_SECTION_VIEWED_KEY = 'last_section_viewed';

type LastSectionsViewed = {
  [reportId: number]: FeedbackSectionId;
};

export const getLastViewedSections = (): LastSectionsViewed => {
  const lastSections = window.localStorage.getItem(LAST_SECTION_VIEWED_KEY);
  if (!lastSections) return {};
  try {
    return JSON.parse(lastSections);
  } catch (e) {
    return {};
  }
};

export const setLastViewedSections = (sections: LastSectionsViewed) => {
  window.localStorage.setItem(
    LAST_SECTION_VIEWED_KEY,
    JSON.stringify(sections),
  );
};

export const addLastViewedSections = (
  reportId: number,
  sectionId: FeedbackSectionId,
) => {
  const sections = getLastViewedSections();
  sections[reportId] = sectionId;
  setLastViewedSections(sections);
};

export const deleteLastViewedSections = () => {
  window.localStorage.removeItem(LAST_SECTION_VIEWED_KEY);
};
